import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { WBSNavButton } from '@/common/WBSNavButton';

interface PaginationControlsProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export const PaginationControls: React.FC<PaginationControlsProps> = ({
  currentPage,
  totalPages,
  onPageChange,
}) => {
  const { t } = useTranslation();
  const [currentPageInput, setCurrentPageInput] = React.useState(currentPage);

  React.useEffect(() => {
    setCurrentPageInput(currentPage);
  }, [currentPage]);

  return (
    <PaginationWrapper>
      <WBSNavButton
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        style={{ minWidth: 86 }}
      >
        {t('wbs.previous')}
      </WBSNavButton>
      <PageGroup>
        {/* Translation Needed */}
        <span>Page</span>
        <PageInput
          type="number"
          min={1}
          max={totalPages}
          value={currentPageInput}
          onChange={(e) => {
            let val = Number(e.target.value);
            if (Number.isNaN(val) || val < 1) val = 1;
            if (val > totalPages) val = totalPages;
            setCurrentPageInput(val);
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              onPageChange(currentPageInput);
            }
          }}
        />
        <span>
          {t('wbs.of')} {totalPages}
        </span>
      </PageGroup>
      <WBSNavButton
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        style={{ minWidth: 62 }}
      >
        {t('wbs.next')}
      </WBSNavButton>
    </PaginationWrapper>
  );
};

const PaginationWrapper = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  gap: 9px;
  justify-content: flex-end;
`;

const PageGroup = styled.div`
  align-items: center;
  display: flex;
  gap: 3px;
`;

const PageInput = styled.input`
  border: none;
  border-radius: 4px;
  box-shadow: var(--shadow-inset-md);
  font-size: 13px;
  padding: 7px 10px;
  width: 137px;
`;
